import { useEffect, useState } from "react";

// Returns a counter that increments at the next local midnight (then reschedules), so
// date-relative UI — e.g. the home trip grouping — refreshes if the tab is left open
// across midnight, instead of staying stale until a manual reload. Use it as a memo dep.
export const useDayTick = (): number => {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const now = new Date();
    // 50ms past local midnight to avoid landing a hair early.
    const nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 50);
    const id = setTimeout(() => setTick((t) => t + 1), nextMidnight.getTime() - now.getTime());
    return () => clearTimeout(id);
  }, [tick]);
  return tick;
};
